import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-configure-discount',
  templateUrl: './configure-discount.component.html',
  styleUrls: ['./configure-discount.component.scss']
})
export class ConfigureDiscountComponent implements OnInit,OnDestroy {
  panelState: any = [true, false, false, false, false];
  entityHashId:any
  loader: boolean = false
  apisub: Subscription
  home_status: any = sessionStorage.getItem('home_service_status')
  shop_status: any = sessionStorage.getItem('shop_service_status')
  virtual_status: any = sessionStorage.getItem('virtual_service_status')
  discountData:any = []
  discountObj: any = {
    discountType: 2,
    discountAmount: null,
    minBillAmount: null,
    maxDiscount: null,
    start_date: '',
    end_date: '',
    otherDiscounts: 0,
    home_service_status: 0,
    shop_service_status: 0,
    virtual_service_status: 0,

  }
  constructor( private router: Router,private navservice:NavigationService,private route:ActivatedRoute,private loaderService: LoaderServiceService, private _apiService: ApiService) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this._apiService.apiResult.subscribe(resData => {
      
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_BILL_DISCOUNT){
        this.discountData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.discountData.push(element)
            // this.toShowCheck = this.discountData[0].discountStatus
          });

          
          this.discountObj.discountType = this.discountData[0].discountType ? this.discountData[0].discountType : 2
          this.discountObj.hashId = this.discountData[0].hashId
          this.discountObj.discountAmount = this.discountData[0].discountAmount
          this.discountObj.minBillAmount = this.discountData[0].minBillAmount 
          this.discountObj.maxDiscount = this.discountData[0].maxDiscount
          this.discountObj.start_date = this.discountData[0].start_date ? (this.discountData[0].start_date) : ''
          this.discountObj.end_date = this.discountData[0].end_date ? this.discountData[0].end_date : ''
          this.discountObj.otherDiscounts = this.discountData[0].otherDiscounts ? this.discountData[0].otherDiscounts : 0
          this.discountObj.shop_service_status = this.discountData[0].shop_service_status ? this.discountData[0].shop_service_status : 0
          this.discountObj.home_service_status = this.discountData[0].home_service_status ? this.discountData[0].home_service_status : 0
          this.discountObj.virtual_service_status = this.discountData[0].virtual_service_status ? this.discountData[0].virtual_service_status : 0
        }
        else{
          // this.toShowCheck = 0
        }
        this.loaderService.showLoader = false
        this.loader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_BILL_DISCOUNT){
        this.router.navigate(['../'], {relativeTo: this.route, queryParamsHandling: 'preserve'})
        // this.parentData.ref.closeAll();
      }
      
    })
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    }) 
    this.loaderService.showLoader = true
    this.loader = true
    this._apiService.getBillDiscount(this.entityHashId)
  }

  selectCheck(event:any,value:any){
    if(event.checked){
      if(value == 0){
        this.discountObj.home_service_status = 1
      }
      else if(value == 1){
        this.discountObj.shop_service_status = 1
      }
      else if(value == 2){
        this.discountObj.virtual_service_status = 1
      }

    }
    else{
      if(value == 0){
        this.discountObj.home_service_status = 0
      }
      else if(value == 1){
        this.discountObj.shop_service_status = 0
      }
      else if(value == 2){
        this.discountObj.virtual_service_status = 0
      }
    }
 
  }
  onToggleChangeOtherDiscount(event:any){
    
    if(event.checked){
      this.discountObj.otherDiscounts = 1
    }else if(!event.checked){
      this.discountObj.otherDiscounts = 0

      
    }
  }

  onSubmitDiscountDetails(){

    let data = JSON.parse(JSON.stringify(this.discountObj))
    data.start_date = this.formatDate1(data.start_date);
    data.end_date = this.formatDate1(data.end_date);


    data.createdBy = data.editedBy = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
    data.businessHashId = this.entityHashId

    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    console.log(data);

    this.loaderService.showLoader = true
    this._apiService.addEditBillDiscount(data)
  }

  formatDate1(dateStr:Date) {

    let curdate = new Date(dateStr).toLocaleString('en-CA', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
  }).slice(0, 10);
      console.log(curdate);
      
      return curdate
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split('/');
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

}
